const raDataDownloaderWorker = () => {
  // eslint-disable-next-line no-restricted-globals
  self.addEventListener("message", (event) => {
    if (!event) return;
    const {
      replacementAnalysisData,
      others,
      replacementPredictionData,
      suggestedOthers,
    } = event.data.exportData;
    const translatedRowData = event.data.translatedRowData;

    const dateFormatter = (date) => {
      if (date) {
        date = new Date(date);

        if (isNaN(date.getTime())) {
          return "Invalid Date";
        }
        const formattedDay = date.getDate().toString().padStart(2, "0");
        const formattedMonth = (date.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const formattedYear = date.getFullYear();

        return `${formattedDay}/${formattedMonth}/${formattedYear}`;
      } else return null;
    };

    const valueLanguageFormatter = (key, data) => {
      const value =
        translatedRowData && translatedRowData[key]
          ? translatedRowData[key][data]
          : "";
      return value;
    };

    const formatUnitForDisplayLocal = (unitValue) => {
      if (typeof unitValue !== "string") return unitValue;

      const unitDisplayMap = {
        "uS/cm": "μS/cm",
        C: "°C",
        F: "°F",
      };
      const trimmedValue = unitValue.trim();
      if (unitDisplayMap[trimmedValue]) return unitDisplayMap[trimmedValue];

      return trimmedValue
        .split("/")
        .map((unitPart) => unitDisplayMap[unitPart.trim()] || unitPart.trim())
        .join("/");
    };

    const otherSheetData = others?.map((data) => {
      return {
        ...data,
        feed: formatUnitForDisplayLocal(data?.feed),
        permeate: formatUnitForDisplayLocal(data?.permeate),
        installation_date: dateFormatter(data.installation_date),
        warranty: data.warranty?.toString() === "true" ? "Yes" : "No",
      };
    });
    const replacementAnalysisSheetData = replacementAnalysisData?.map(
      (data) => {
        return {
          ...data,
          forecasted_date: dateFormatter(data.forecasted_date),
          trigger: valueLanguageFormatter("trigger", data.trigger),
          explanation: valueLanguageFormatter("explanation", data.explanation),
        };
      },
    );

    const dates = [
      // considering one parameters Dates as all of them have same
      ...replacementPredictionData.norm_salt_passage.historical_x,
      ...replacementPredictionData.norm_salt_passage.forecasted_x,
    ];
    const replacementPredictionSheetData = dates.map((date, index) => {
      const data = {
        date: date,
      };
      const normalizedCategories = Object.keys(replacementPredictionData);
      normalizedCategories.forEach((category) => {
        const ColumnValues = [
          ...replacementPredictionData[category].historical_y,
          ...replacementPredictionData[category].forecasted_y,
        ];
        data[category] = ColumnValues[index];
      });
      return data;
    });

    // processedDataSheetData is now pre-processed before being sent to worker
    const { processedDataSheetData } = event.data.exportData;

    postMessage({
      replacementAnalysisSheetData,
      otherSheetData,
      replacementPredictionSheetData,
      processedDataSheetData,
      suggestedOtherSheetData: suggestedOthers || null,
    });
  });
};

export default raDataDownloaderWorker;
